import { createTransition } from './createTransition';

export function getFocusOutlineBaseStyle(): string {
  return `
    ${createTransition('border, box-shadow', 'ultra-fast')}
  `;
}
